import React, { useContext, useState } from "react"
import styled from "styled-components"
import CountUp from "react-countup"
import { LinkWrapper as Link } from "../../utils/linkWrapper"
import { useIntercom } from "react-use-intercom"

// ======================
// 	🧱🧱 COMPONENT 🧱🧱
// ======================
const Results = ({ amount = 0, limit = 20 }) => {
  const { boot, shutdown, hide, show, update } = useIntercom()

  const [currentAmount, setCurrentAmount] = useState(amount)
  const [previousAmount, setPreviousAmount] = useState(0)

  if (currentAmount != amount) {
    setPreviousAmount(currentAmount)
    setCurrentAmount(amount)
  }

  return (
    <ResultContainer>
      <Blank />
      <Content>
        <CountUp
          start={previousAmount}
          end={currentAmount}
          className="results-count-up"
          duration={1}
        />
        <p>Beds that fit your needs</p>
        {currentAmount > limit ? (
          <p>Answer more questions to see the results!</p>
        ) : (
          <p>Your results are below!</p>
        )}
      </Content>
      <Contact>
        <span>Need help? </span>
        <button type="button" onClick={show}>
          Chat live
        </button>{" "}
        or send us a WhatsApp on{" "}
        <a href="https://wa.me/+27828649320" target="_blank">
          067 310 4234
        </a>
      </Contact>
    </ResultContainer>
  )
}

// ====================
// 	💅🏼💅🏼 STYLES 💅🏼💅🏼
// ====================

const ResultContainer = styled.div`
  background-color: #223247;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 30px;
  text-align: center;
  position: sticky;
  top: 20px;
`
const Content = styled.div`
  p,
  .results-count-up {
    color: white;
  }

  .results-count-up {
    font-size: 48px;
    font-weight: 900;
  }

  p {
    font-size: 19px;
  }
`

const Contact = styled.div`
  margin-top: 40px;
  color: #b6c9e3;
  span {
    font-weight: bold;
  }
  a,
  button {
    transition: 0.2s all ease-in-out;
    color: #b6c9e3;
    text-decoration: underline;
    &:hover {
      opacity: 0.8;
    }
  }
  button {
    background-color: #223247;
    display: inline-block;
    border: none;
    cursor: pointer;
    text-align: center;
    -moz-appearance: none;
    padding: 0;
  }
`

const Blank = styled.div`
  height: 30px;
`

const Button = styled(Link)`
  color: white;
  background-color: #fd3237;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 1fr 50px;
  overflow: hidden;
  align-items: center;
  margin: 10px 0;
  transition: 0.2s all ease-in-out;
  &:hover {
    transform: translateX(3px);
  }

  div {
    padding: 5px;
  }

  > span.icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #dc262a;
    height: 100%;
    padding: 10px 0;
  }
`

export default Results
